import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { IncentiveDetails } from '../../../../models/incentive-details.model';
import { NotesModel } from '../../../../models/notes.model';
import { AppConstants } from '../../../common/app-constants';
import { SettingsService } from '../../../common/settings.service';
import { CommonSharedModule } from '../../../common/shared.module';
import { OsmosisEditService } from '../../../services/osmosis-edit.service';

@Component({
  selector: 'app-incentive-details-header',
  templateUrl: './incentive-details-header.component.html',
  styleUrls: ['./incentive-details-header.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class IncentiveDetailsHeaderComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private settingsServices: SettingsService,
    private osmEdit: OsmosisEditService
  ) {}

  @Input() incentiveDetails!: IncentiveDetails;
  formIncentiveDetails!: FormGroup;
  formNotes!: FormGroup;
  addNotes!: NotesModel;
  notes!: NotesModel[];
  incentiveName = AppConstants.incentiveName;

  ngOnInit() {
    this.onFormGroup();
  }

  onFormGroup() {
    this.formIncentiveDetails = this.formBuilder.group({
      engagementKey: [''],
      engagementName: [''],
      requestDate: [''],
      pMOPartnerName: [''],
      enagementTaskOwner: [''],
      enagementPMOTenantName: [''],
      enagementNextSteps: [''],
      enagementType: [''],
      engagementRequestID: [''],
      enagementStatus: [''],
      incentiveStatus: ['']
    });

    this.formNotes = this.formBuilder.group({
      notes: ['']
    });

    this.getDetails();
    this.getNotesList();
  }

  getDetails() {
    this.formIncentiveDetails.patchValue({
      engagementKey: this.incentiveDetails.requestDetailId,
      engagementName: this.incentiveDetails.engagementName,
      requestDate: this.incentiveDetails.requestDate,
      pMOPartnerName: this.incentiveDetails.pmoConfirmedPartnerName,
      enagementTaskOwner: this.incentiveDetails.taskOwnerName,
      enagementPMOTenantName: this.incentiveDetails.pmoConfirmedTenantName,
      enagementNextSteps: this.incentiveDetails.pmoNextStepName,
      enagementType: this.incentiveDetails.deliveryName,
      engagementRequestID: this.incentiveDetails.partnerConfirmNum,
      enagementStatus: this.incentiveDetails.engagementStatus,
      incentiveStatus: this.incentiveDetails.incentiveStatus
    });
  }

  onSubmitNotes() {
    this.addNotes = {
      requestDetailId: this.incentiveDetails.requestDetailId,
      userAlias: this.settingsServices.AliasName || '',
      notes: this.formNotes.controls['notes'].value
    };

    this.osmEdit.addNotes(this.addNotes).subscribe(() => {
      this.getNotesList();
    });

    this.formNotes.controls['notes'].setValue('');
  }

  getNotesList(): void {
    this.osmEdit
      .getNotes(this.incentiveDetails.requestDetailId || -1)
      .subscribe(noteslistService => {
        this.notes = noteslistService;
      });
  }

  get release(): string {
    return environment.isProdEnvironment ? 'Prod' : 'Dev';
  }

  refresh(incDetails: IncentiveDetails) {
    this.incentiveDetails = incDetails;
    this.getDetails();
  }

  setValues() {
    this.osmEdit
      .getIncentiveDataByRequestDetailsById(
        this.incentiveDetails.requestDetailId || -1
      )
      .subscribe(result => {
        this.incentiveDetails = result;
        this.getDetails();
      });
  }
}
